import AdminClassLayout from "@Organism/Admin/Class";
import { getClassesAdmin } from "@Services/admin";
import { Suspense } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";

export async function loader(route) {
  const params = new URLSearchParams(route?.request?.url);
  const page = params?.get("p") || 1;
  const limit = params?.get("l") || 5;
  const type = params.get("t") || "PRAKERJA";
  const search = params.get("s") || "";
  const classesActive = getClassesAdmin(type, page, limit, "", search);
  const classesInactive = getClassesAdmin(type, page, limit, 1, search);

  return defer({
    dataClassesActive: classesActive,
    dataClassesInactive: classesInactive,
  });
}

export default function AdminClassPage() {
  const { dataClassesActive, dataClassesInactive } = useLoaderData();

  return (
    <Suspense fallback={<p>Loading....</p>}>
      <Await resolve={dataClassesActive} errorElement={<>error</>}>
        {(dataClassesActive) => (
          <Suspense fallback={<p>Loading....</p>}>
            <Await resolve={dataClassesInactive} errorElement={<>error</>}>
              {(dataClassesInactive) => (
                <AdminClassLayout
                  dataActive={dataClassesActive}
                  dataInactive={dataClassesInactive}
                />
              )}
            </Await>
          </Suspense>
        )}
      </Await>
    </Suspense>
  );
}
